var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPizzaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.577,26.996C59.212,14.405,49.595,4.788,37.004,2.423c-0.239-0.04-0.479-0.077-0.72-0.112    C35.08,2.139,34,3.084,34,4.301V30h25.699c1.217,0,2.161-1.08,1.989-2.284C61.654,27.475,61.617,27.235,61.577,26.996z",
    style: {
      fill: "#CF9E76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.854,6.081C12.812,7.221,1.091,20.245,2.056,35.786C2.921,49.73,14.27,61.079,28.213,61.944    c15.541,0.965,28.566-10.757,29.706-25.798C58.007,34.988,57.078,34,55.916,34H30V8.084C30,6.922,29.012,5.993,27.854,6.081z",
    style: {
      fill: "#CF9E76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,9C16.193,9,5,20.193,5,34s11.193,25,25,25s25-11.193,25-25H30V9z",
    style: {
      fill: "#DFB28B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,5v25h25C59,16.745,47.255,5,34,5z",
    style: {
      fill: "#DFB28B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.911,30c-0.825-9.986-7.759-18.235-17.059-21L37,8.529c-0.979-0.208-1.981-0.355-3-0.44V30    H55.911z",
    style: {
      fill: "#FCD770"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,34V12C17.85,12,8,21.85,8,34s9.85,22,22,22s22-9.85,22-22H30z",
    style: {
      fill: "#FCD770"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 49,
    r: 2,
    style: {
      fill: "#FC6E51"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 2,
    style: {
      fill: "#B27946"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 17,
    r: 2,
    style: {
      fill: "#FC6E51"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 36,
    r: 2,
    style: {
      fill: "#B27946"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 42,
    r: 2,
    style: {
      fill: "#B27946"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 34,
    r: 2,
    style: {
      fill: "#FC6E51"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.916,33H31V8.084c0-0.835-0.352-1.641-0.966-2.21c-0.609-0.563-1.423-0.852-2.256-0.79    c-15.713,1.19-27.7,14.991-26.721,30.764C1.96,50.392,13.607,62.04,28.151,62.942c0.604,0.037,1.204,0.056,1.802,0.056    c15.009-0.001,27.818-11.665,28.963-26.776c0.062-0.824-0.226-1.646-0.79-2.256C57.557,33.352,56.751,33,55.916,33z     M28.274,60.946C14.736,60.106,3.894,49.263,3.054,35.725C2.142,21.037,13.301,8.187,27.929,7.078    c0.271-0.024,0.541,0.071,0.746,0.263C28.885,7.536,29,7.8,29,8.084v2.941C16.78,11.551,7,21.653,7,34c0,12.683,10.317,23,23,23    c10.758,0,19.971-7.309,22.403-17.773l-1.947-0.453C48.234,48.327,39.823,55,30,55C18.421,55,9,45.579,9,34    c0-3.091,0.688-6.018,1.893-8.664c0.121,0.101,0.248,0.218,0.4,0.371C11.839,26.253,12.586,27,14,27s2.161-0.747,2.707-1.293    C17.197,25.217,17.438,25,18,25v-2c-1.414,0-2.161,0.747-2.707,1.293C14.803,24.783,14.562,25,14,25s-0.803-0.217-1.293-0.707    c-0.241-0.241-0.527-0.52-0.887-0.758c3.475-6.013,9.835-10.136,17.18-10.485V35h21.966c-0.029,0.626-0.076,1.25-0.16,1.865    l1.982,0.27c0.096-0.704,0.147-1.419,0.178-2.135h2.95c0.284,0,0.548,0.115,0.743,0.325c0.19,0.206,0.283,0.471,0.263,0.746    C55.812,50.699,42.98,61.869,28.274,60.946z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,46c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S24.654,46,23,46z M23,50c-0.552,0-1-0.448-1-1s0.448-1,1-1    s1,0.448,1,1S23.552,50,23,50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,24c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S37,22.346,37,24z M41,24c0,0.552-0.448,1-1,1s-1-0.448-1-1    s0.448-1,1-1S41,23.448,41,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,33c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S27.654,33,26,33z M26,37c-0.552,0-1-0.448-1-1s0.448-1,1-1    s1,0.448,1,1S26.552,37,26,37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,39c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S45.654,39,44,39z M44,43c-0.552,0-1-0.448-1-1s0.448-1,1-1    s1,0.448,1,1S44.552,43,44,43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S17.654,31,16,31z M16,35c-0.552,0-1-0.448-1-1s0.448-1,1-1    s1,0.448,1,1S16.552,35,16,35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,50c-0.562,0-0.803-0.217-1.293-0.707C33.161,48.747,32.414,48,31,48v2c0.562,0,0.803,0.217,1.293,0.707    C32.839,51.253,33.586,52,35,52s2.161-0.747,2.707-1.293C38.197,50.217,38.438,50,39,50v-2c-1.414,0-2.161,0.747-2.707,1.293    C35.803,49.783,35.562,50,35,50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.679,27.575c-0.036-0.251-0.074-0.501-0.117-0.749l-0.003-0.015C60.122,13.836,50.164,3.878,37.174,1.438    c-0.248-0.043-0.498-0.081-0.748-0.117c-0.862-0.12-1.729,0.136-2.387,0.705C33.379,2.6,33,3.429,33,4.301V31h26.699    c0.872,0,1.701-0.379,2.274-1.039C62.544,29.303,62.801,28.434,62.679,27.575z M60.463,28.65C60.267,28.876,59.996,29,59.699,29    h-2.904c-1.182-9.78-8.167-18.135-17.659-20.959l-0.57,1.918c3.018,0.897,5.752,2.413,8.097,4.37C45.682,14.822,45,15.828,45,17    c0,1.654,1.346,3,3,3c1.101,0,2.055-0.603,2.577-1.49c2.221,3.053,3.698,6.646,4.204,10.49H35V17.425    c0.091,0.083,0.184,0.173,0.293,0.282C35.839,18.253,36.586,19,38,19s2.161-0.747,2.707-1.293C41.197,17.217,41.438,17,42,17v-2    c-1.414,0-2.161,0.747-2.707,1.293C38.803,16.783,38.562,17,38,17s-0.803-0.217-1.293-0.707c-0.399-0.399-0.91-0.904-1.707-1.147    V9.21c0.603,0.078,1.203,0.172,1.792,0.297l0.416-1.957C36.483,7.397,35.743,7.287,35,7.198V4.301c0-0.297,0.124-0.567,0.35-0.764    c0.223-0.193,0.507-0.276,0.794-0.235c0.231,0.032,0.462,0.068,0.676,0.104c12.157,2.283,21.487,11.611,23.772,23.767    c0.039,0.227,0.074,0.454,0.106,0.685C60.739,28.146,60.656,28.428,60.463,28.65z M48,16c0.552,0,1,0.448,1,1s-0.448,1-1,1    s-1-0.448-1-1S47.448,16,48,16z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 49,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 45,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 37,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 31,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 19,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 25,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 22,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 14,
    y: 42
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizzaIcon);
export default __webpack_public_path__ + "static/media/pizza_icon.4c8de6c864bb983b0ef9cb1979d01458.svg";
export { ForwardRef as ReactComponent };